<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Έκδοση Τιμολογίου</h4>
        </CCardHeader>
        <CModal
          class="modalAlert"
          :show.sync="alertIsShown"
          :centered="true"
          size="lg"
        >
          <CAlert
            closeButton
            :show.sync="alertIsShown"
            color="primary"
            fade
          >
            {{ message }}
          </CAlert>
        </CModal>
        <CCardBody>
          <!-- Navigation Buttons -->
          <CRow class="mb-4">
            <CCol>
              <CButtonGroup class="w-100">
                <CButton
                  :color="activeTab === 0 ? 'primary' : 'light'"
                  @click="changeTab(0)"
                  class="invoice-nav-btn"
                >
                  <CIcon name="cil-file" class="mr-1" />
                  Έκδοση Τιμολογίου
                </CButton>
                <CButton
                  :color="activeTab === 1 ? 'primary' : 'light'"
                  @click="changeTab(1)"
                  class="invoice-nav-btn"
                >
                  <CIcon name="cil-globe-alt" class="mr-1" />
                  English Invoice
                </CButton>
                <CButton
                  :color="activeTab === 2 ? 'primary' : 'light'"
                  @click="changeTab(2)"
                  class="invoice-nav-btn"
                >
                  <CIcon name="cil-cloud-upload" class="mr-1" />
                  Καταχώρηση B2G
                </CButton>
                <CButton
                  :color="activeTab === 3 ? 'primary' : 'light'"
                  @click="changeTab(3)"
                  class="invoice-nav-btn"
                >
                  <CIcon name="cil-settings" class="mr-1" />
                  Ρυθμίσεις
                </CButton>
                <CButton
                  :color="activeTab === 4 ? 'primary' : 'light'"
                  @click="changeTab(4)"
                  class="invoice-nav-btn"
                >
                  <CIcon name="cil-credit-card" class="mr-1" />
                  Πληρωμές
                </CButton>
              </CButtonGroup>
            </CCol>
          </CRow>

          <!-- Greek Invoice Tab -->
          <div v-show="activeTab === 0">
                <CCard>
                  <CCardBody>
                    <CRow class="form-row form-group mb-0">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Τύπος παραστατικού</label>

                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="document_series" 
                          id="document_series" 
                          :options="document_series_options"
                          label="label"
                          track-by="value"
                          @input="changeSeiraOptions"  
                          :maxHeight="640"
                          :allow-empty="false"
                        >
                        </multiselect>
                      </CCol>
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Σειρά παραστατικού</label>

                        <div v-if="document_series_seira_options.length === 1">
                          <CInput type="text" class="customInputHeight"  v-model="document_series_seira.label" :disabled='disabledField'></CInput>
                        </div>
                        <div v-else>
                          <multiselect 
                            :select-label="'Select'"
                            :deselect-label="'Remove'"
                            v-model="document_series_seira" 
                            id="document_series_seira" 
                            :options="document_series_seira_options"
                            @input="selectedDocSer($event)"
                            label="label"
                            track-by="value">
                          </multiselect>
                        </div>
                      </CCol>

                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Αριθμός Παραστατικού</label>
                        <CInput type="text" id="document_number" class="customInputHeight" placeholder="Αριθμός Παραστατικού" v-model="document_number" :disabled='disabledField'></CInput>
                      </CCol>
                    </CRow>
                    <CRow class="form-row form-group mb-3">
                      <CCol xl="12" lg="12">
                        <label class="requiredLabel">Πελάτης</label>
                        <CRow>
                          <CCol>
                            <multiselect 
                              :select-label="'Select'"
                              :deselect-label="'Remove'"
                              v-model="client" 
                              id="client" 
                              :options="clients_options"
                              label="label"
                              @input="selectedClient($event)"
                              @remove="removeSelectedClient"
                              :disabled="!!invoice_client"
                              track-by="value">
                            </multiselect>
                          </CCol>
                          <CCol lg="auto" v-if="client">
                            <CButton 
                              @click="$router.push({path: '/clients/' + client.value + '/edit'})" 
                              color="primary"
                              class="mb-2 customBtnHeight"
                            >
                              Επεξεργασία Πελάτη
                            </CButton>
                          </CCol>
                        </CRow>
                      </CCol>
                      <!-- <CCol xl="4" lg="12">
                        Πελάτης Τιμολογίου

                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="invoice_client" 
                          id="invoice_client" 
                          :options="invoice_clients_options"
                          label="label"
                          @input="selectedInvoiceClient($event)"
                          @remove="removeSelectedClient"
                          :disabled="!!client"
                          track-by="value">
                        </multiselect>
                      </CCol> -->
                    </CRow>
                      
                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">ΑΦΜ Πελάτη</label>
                        <CInput type="text" id="client_afm" placeholder="ΑΦΜ Πελάτη" v-model="client_afm"></CInput>
                      </CCol>
                      
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">ΔΟΥ Πελάτη</label>
                        <CInput type="text" id="client_doy" placeholder="ΔΟΥ Πελάτη" v-model="client_doy"></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        Υπεύθυνος Επικοινωνίας
                        <CInput type="text" id="client_name" placeholder="Υπεύθυνος Επικοινωνίας" v-model="client_name"></CInput>
                      </CCol>
                    </CRow>
                      
                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        Τηλ. Επικοινωνίας (1):	
                        <CInput type="text" id="client_phone" placeholder="Τηλέφωνο" v-model="client_phone"></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        Τηλ. Επικοινωνίας (2):	
                        <CInput type="text" id="client_phone_2" placeholder="Τηλέφωνο" v-model="client_phone_2"></CInput>
                      </CCol>
                      
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Διεύθυνση Πελάτη</label>
                        <CInput type="text" id="client_address" placeholder="Διεύθυνση Πελάτη" v-model="client_address"></CInput>
                      </CCol>
                    </CRow>

                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Πόλη</label>
                        <CInput type="text" id="client_town" placeholder="Πόλη" v-model="client_town"></CInput>
                      </CCol>
                      
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Νομός</label>
                        <CInput type="text" id="client_state" placeholder="Νομός" v-model="client_state"></CInput>
                      </CCol>
                      
                      <CCol xl="4" lg="12">
                        Ταχυδρομικός Κώδικας
                        <CInput type="text" id="client_postcode" placeholder="Ταχυδρομικός Κώδικας" v-model="client_postcode"></CInput>
                      </CCol>
                    </CRow>
                    
                    <CRow class="form-row form-group">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Ημερομηνία</label>
                        
                        <CInput
                          type="date"
                          id="date"
                          v-model="date"
                        />
                      </CCol>
                    </CRow>

                    <div>
                      <CButton 
                        :disabled="!(!!client || !!invoice_client)"
                        @click="collapse = !collapse" 
                        color="primary"
                        class="mb-2"
                      >
                        Υπηρεσίες
                      </CButton>
                      <CCollapse :show="collapse">
                        <CCard body-wrapper>
                          <CRow>
                            <CCol xl="6" lg="12">
                              Υποθέσεις
                              <multiselect 
                                :select-label="'Select'"
                                :deselect-label="'Remove'"
                                v-model="services" 
                                id="services" 
                                :options="servicesOptions"
                                label="label"
                                @input="selectedIsoCases($event)"
                                @remove="removeSelectedCases"
                                :disabled="!!invoice_services || !!invoice_client || !client"
                                track-by="value">
                              </multiselect>
                            </CCol>

                            <CCol xl="6" lg="12">
                              Υπηρεσίες Τιμολογίου
                              <multiselect 
                                :select-label="'Select'"
                                :deselect-label="'Remove'"
                                v-model="invoice_services" 
                                id="invoice_services" 
                                :options="invoice_servicesOptions"
                                @input="selectedCases($event)"
                                @remove="removeSelectedCases"
                                :disabled="!!services || !(!!client || !!invoice_client)"
                                label="label"
                                track-by="value">
                              </multiselect>
                            </CCol>
                          </CRow>

                          <CRow class="mt-3">
                            <CCol xl="4" lg="12">
                              Ποσότητα
                              <CInput type="number" min="1" id="quantity" placeholder="Ποσότητα" v-model="quantity" @input="check_if_negative_quantity($event)"></CInput>
                            </CCol>

                            <CCol xl="4" lg="12">
                              Τιμή χωρίς ΦΠΑ (τεμάχιο, σε €)
                              <CInput type="text" inputmode="decimal" id="price_without_vat" placeholder="Τιμή" v-model="price_without_vat" @input="calculate_final_price($event)"></CInput>
                            </CCol>
                            
                            <CCol xl="4" lg="12">
                              Συνολική Αξία (τεμάχιο, σε €)
                              <CInput type="text" inputmode="decimal" id="total_price" placeholder="Συνολική Αξία" v-model="total_price" @input="calculate_price_without_vat($event)"></CInput>
                            </CCol>
                          </CRow>
                          
                          <CRow>
                            <CCol xl="8" lg="12">
                              Σχόλια
                              <CTextarea
                                rows="1"
                                v-model="notes"
                                class="textareaHeight"
                              />
                            </CCol>
                          </CRow>

                          <CCol sm="12" class="mt-2 pl-0" v-show="showAdd && showAddVat">
                            <CButton color="primary" @click="addRow()">Προσθήκη</CButton>
                          </CCol>
                        </CCard>
                      </CCollapse>
                    </div>
                    <br>

                      <CDataTable
                        :items="serviceLoopToDatatable"
                        :fields="fields"
                        :items-per-page="10"
                        pagination
                        hover
                        :loading="loading"
                        sorter
                        class="invoicesTable"
                      >
                      <template #services="{item}">
                        <td>
                          <span v-if="item.services">
                            {{item.notes}}
                          </span>
                          <span v-if="item.invoice_services">
                            {{item.notes}}
                          </span>
                        </td>
                      </template>
                      <template #quantity="{item}">
                        <td>
                          <span v-if="item.quantity">
                            {{ item.quantity }}
                          </span>
                        </td>
                      </template>
                      <template #price_without_vat="{item}">
                        <td>
                          <span v-if="item.price_without_vat">
                            {{ item.price_without_vat }}€
                          </span>
                        </td>
                      </template>
                      <template #total_price="{item}">
                        <td>
                          <span v-if="item.total_price">
                            {{ item.total_price }}€
                          </span>
                        </td>
                      </template>
                      <template #delete="{item}">
                        <td>
                          <span v-if="you!=item.id" @click="deleteRow(item.id)" class="minusBtn"><CIcon :content="cilMinusBtn" color="danger" :height="20" /></span>
                        </td>
                      </template>
                    </CDataTable>

                    <CButton v-if="serviceLoopToDatatable.length != 0" color="primary" class="float-right" @click="store()">Δημιουργία</CButton>

                  </CCardBody>
                </CCard>
          </div>

          <!-- English Invoice Tab -->
          <div v-show="activeTab === 1">
                <CCard>
                  <CCardBody>
                    <CRow class="form-row form-group mb-0">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Τύπος παραστατικού</label>

                        <multiselect
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="document_series"
                          id="document_series"
                          :options="document_series_options"
                          label="label"
                          track-by="value"
                          @input="changeSeiraOptions"
                          :maxHeight="640"
                          :allow-empty="false"
                        >
                        </multiselect>
                      </CCol>
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Σειρά παραστατικού</label>

                        <div v-if="document_series_seira_options.length === 1">
                          <CInput type="text" class="customInputHeight"  v-model="document_series_seira.label" :disabled='disabledField'></CInput>
                        </div>
                        <div v-else>
                          <multiselect
                            :select-label="'Select'"
                            :deselect-label="'Remove'"
                            v-model="document_series_seira"
                            id="document_series_seira"
                            :options="document_series_seira_options"
                            @input="selectedDocSer($event)"
                            label="label"
                            track-by="value">
                          </multiselect>
                        </div>
                      </CCol>

                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Αριθμός Παραστατικού</label>
                        <CInput type="text" id="document_number" class="customInputHeight" placeholder="Αριθμός Παραστατικού" v-model="document_number" :disabled='disabledField'></CInput>
                      </CCol>
                    </CRow>
                    <CRow class="form-row form-group mb-3">
                      <CCol xl="12" lg="12">
                        <label class="requiredLabel">Πελάτης</label>
                        <CRow>
                          <CCol>
                            <multiselect
                              :select-label="'Select'"
                              :deselect-label="'Remove'"
                              v-model="client"
                              id="client"
                              :options="clients_options"
                              label="label"
                              @input="selectedClient($event)"
                              @remove="removeSelectedClient"
                              :disabled="!!invoice_client"
                              track-by="value">
                            </multiselect>
                          </CCol>
                          <CCol lg="auto" v-if="client">
                            <CButton
                              @click="$router.push({path: '/clients/' + client.value + '/edit'})"
                              color="primary"
                              class="mb-2 customBtnHeight"
                            >
                              Επεξεργασία Πελάτη
                            </CButton>
                          </CCol>
                        </CRow>
                      </CCol>
                    </CRow>

                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">ΑΦΜ Πελάτη</label>
                        <CInput type="text" id="client_afm" placeholder="ΑΦΜ Πελάτη" v-model="client_afm"></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">ΔΟΥ Πελάτη</label>
                        <CInput type="text" id="client_doy" placeholder="ΔΟΥ Πελάτη" v-model="client_doy"></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        Υπεύθυνος Επικοινωνίας
                        <CInput type="text" id="client_name" placeholder="Υπεύθυνος Επικοινωνίας" v-model="client_name"></CInput>
                      </CCol>
                    </CRow>

                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        Τηλ. Επικοινωνίας (1):
                        <CInput type="text" id="client_phone" placeholder="Τηλέφωνο" v-model="client_phone"></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        Τηλ. Επικοινωνίας (2):
                        <CInput type="text" id="client_phone_2" placeholder="Τηλέφωνο" v-model="client_phone_2"></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Διεύθυνση Πελάτη</label>
                        <CInput type="text" id="client_address" placeholder="Διεύθυνση Πελάτη" v-model="client_address"></CInput>
                      </CCol>
                    </CRow>

                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Πόλη</label>
                        <CInput type="text" id="client_town" placeholder="Πόλη" v-model="client_town"></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Νομός</label>
                        <CInput type="text" id="client_state" placeholder="Νομός" v-model="client_state"></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        Ταχυδρομικός Κώδικας
                        <CInput type="text" id="client_postcode" placeholder="Ταχυδρομικός Κώδικας" v-model="client_postcode"></CInput>
                      </CCol>
                    </CRow>

                    <CRow class="form-row form-group">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Ημερομηνία</label>

                        <CInput
                          type="date"
                          id="date"
                          v-model="date"
                        />
                      </CCol>
                    </CRow>

                    <div>
                      <CButton
                        :disabled="!(!!client || !!invoice_client)"
                        @click="collapse = !collapse"
                        color="primary"
                        class="mb-2"
                      >
                        Υπηρεσίες
                      </CButton>
                      <CCollapse :show="collapse">
                        <CCard body-wrapper>
                          <CRow>
                            <CCol xl="6" lg="12">
                              Υποθέσεις
                              <multiselect
                                :select-label="'Select'"
                                :deselect-label="'Remove'"
                                v-model="services"
                                id="services"
                                :options="servicesOptions"
                                label="label"
                                @input="selectedIsoCases($event)"
                                @remove="removeSelectedCases"
                                :disabled="!!invoice_services || !!invoice_client || !client"
                                track-by="value">
                              </multiselect>
                            </CCol>

                            <CCol xl="6" lg="12">
                              Υπηρεσίες Τιμολογίου
                              <multiselect
                                :select-label="'Select'"
                                :deselect-label="'Remove'"
                                v-model="invoice_services"
                                id="invoice_services"
                                :options="invoice_servicesOptions"
                                @input="selectedCases($event)"
                                @remove="removeSelectedCases"
                                :disabled="!!services || !(!!client || !!invoice_client)"
                                label="label"
                                track-by="value">
                              </multiselect>
                            </CCol>
                          </CRow>

                          <CRow class="mt-3">
                            <CCol xl="4" lg="12">
                              Ποσότητα
                              <CInput type="number" min="1" id="quantity" placeholder="Ποσότητα" v-model="quantity" @input="check_if_negative_quantity($event)"></CInput>
                            </CCol>

                            <CCol xl="4" lg="12">
                              Τιμή χωρίς ΦΠΑ (τεμάχιο, σε €)
                              <CInput type="text" inputmode="decimal" id="price_without_vat" placeholder="Τιμή" v-model="price_without_vat" @input="calculate_final_price($event)"></CInput>
                            </CCol>

                            <CCol xl="4" lg="12">
                              Συνολική Αξία (τεμάχιο, σε €)
                              <CInput type="text" inputmode="decimal" id="total_price" placeholder="Συνολική Αξία" v-model="total_price" @input="calculate_price_without_vat($event)"></CInput>
                            </CCol>
                          </CRow>

                          <CRow>
                            <CCol xl="8" lg="12">
                              Σχόλια
                              <CTextarea
                                rows="1"
                                v-model="notes"
                                class="textareaHeight"
                              />
                            </CCol>
                          </CRow>

                          <CCol sm="12" class="mt-2 pl-0" v-show="showAdd && showAddVat">
                            <CButton color="primary" @click="addRow()">Προσθήκη</CButton>
                          </CCol>
                        </CCard>
                      </CCollapse>
                    </div>
                    <br>

                      <CDataTable
                        :items="serviceLoopToDatatable"
                        :fields="fields"
                        :items-per-page="10"
                        pagination
                        hover
                        :loading="loading"
                        sorter
                        class="invoicesTable"
                      >
                      <template #services="{item}">
                        <td>
                          <span v-if="item.services">
                            {{item.notes}}
                          </span>
                          <span v-if="item.invoice_services">
                            {{item.notes}}
                          </span>
                        </td>
                      </template>
                      <template #quantity="{item}">
                        <td>
                          <span v-if="item.quantity">
                            {{ item.quantity }}
                          </span>
                        </td>
                      </template>
                      <template #price_without_vat="{item}">
                        <td>
                          <span v-if="item.price_without_vat">
                            {{ item.price_without_vat }}€
                          </span>
                        </td>
                      </template>
                      <template #total_price="{item}">
                        <td>
                          <span v-if="item.total_price">
                            {{ item.total_price }}€
                          </span>
                        </td>
                      </template>
                      <template #delete="{item}">
                        <td>
                          <span v-if="you!=item.id" @click="deleteRow(item.id)" class="minusBtn"><CIcon :content="cilMinusBtn" color="danger" :height="20" /></span>
                        </td>
                      </template>
                    </CDataTable>

                    <CButton v-if="serviceLoopToDatatable.length != 0" color="primary" class="float-right" @click="store()">Δημιουργία</CButton>

                  </CCardBody>
                </CCard>
          </div>

          <!-- B2G Registration Tab -->
          <div v-show="activeTab === 2">
            <AddExternalB2GInvoice />
          </div>

          <!-- Settings Tab -->
          <div v-show="activeTab === 3">
                <CCard>
                  <CCardBody>
                    <div class="form-row form-group">
                      <CCol sm="3">
                        Καθεστώς ΦΠΑ
                      </CCol>
                      <CCol sm="9">
                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="vat_price" 
                          id="vat_price" 
                          :options="vat_prices_options"
                          label="label"
                          track-by="value">
                        </multiselect>
                      </CCol>
                    </div>

                    <div class="form-row form-group">
                      <CCol sm="3">
                        Γλώσσα
                      </CCol>
                      <CCol sm="9">
                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="invoice_lang" 
                          id="invoice_lang" 
                          :options="invoice_lang_options"
                          @input="selectedInvoiceLanguage($event)"
                          label="label"
                          track-by="value">
                        </multiselect>
                      </CCol>
                    </div>

                    <div 
                      class="form-row form-group"
                      v-if="vat_price.value === 0"
                    >
                      <CCol sm="3">
                        Κατηγορία Αιτίας Εξαίρεσης ΦΠΑ
                      </CCol>
                      <CCol sm="9">
                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="exception_category" 
                          id="exception_category" 
                          :options="exception_categories"
                          label="label"
                          track-by="value">
                        </multiselect>
                      </CCol>
                    </div>
                  </CCardBody>
                </CCard>
          </div>

          <!-- Payments Tab -->
          <div v-show="activeTab === 4">
                <CCard>
                  <CCardBody>
                    <div class="form-row form-group">
                      <CCol sm="3">
                        Κατάσταση πληρωμής
                      </CCol>
                      <CCol sm="9">
                        <multiselect
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="payment_status"
                          id="payment_status"
                          label="label"
                          track-by="value"
                          @input="changePaidAmount()"
                          :options="payment_options">
                        </multiselect>
                      </CCol>
                    </div>

                    <div class="form-row form-group" v-show="payment_status && payment_status.value != 0">
                      <CCol sm="3">
                        Ποσό πληρωμής
                      </CCol>
                      <CCol sm="9">
                        <CInput type="number" class="customInputHeight" v-model="paid_amount"></CInput>
                      </CCol>
                    </div>
                    <p>Υπόλοιπο: {{ remainingPrice }}€</p>

                    <CButton v-if="serviceLoopToDatatable.length != 0" color="primary" class="float-right" @click="store()">Δημιουργία</CButton>
                  </CCardBody>
                </CCard>
          </div>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import { DatePicker } from 'v-calendar'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { cilMinus, cilSettings } from '@coreui/icons'
import AddExternalB2GInvoice from './AddExternalB2GInvoice.vue'

const fieldsEN = [
  {
    key: 'id', 
    label: 'No.', 
    sorter: false, 
    filter: false
  },
  {
    key: 'services', 
    label: 'Services', 
    sorter: false, 
    filter: false
  },
  // {
  //   key: 'notes', 
  //   label: 'Services Description', 
  //   sorter: false, 
  //   filter: false
  // },
  {
    key: 'quantity', 
    label: 'Quantity', 
    sorter: false, 
    filter: false
  },
  {
    key: 'price_without_vat', 
    label: 'Unit Price', 
    sorter: false, 
    filter: false
  },
  {
    key: 'total_price', 
    label: 'Amount', 
    sorter: false, 
    filter: false
  },
  {
    key: 'delete', 
    label: '', 
    sorter: false, 
    filter: false
  }
];

const fieldsEL = [
  {
    key: 'id', 
    label: 'Α/Α', 
    sorter: false, 
    filter: false
  },
  {
    key: 'services', 
    label: 'Υπηρεσίες', 
    sorter: false, 
    filter: false
  },
  // {
  //   key: 'notes', 
  //   label: 'Περιγραφή', 
  //   sorter: false, 
  //   filter: false
  // },
  {
    key: 'quantity', 
    label: 'Ποσότητα', 
    sorter: false, 
    filter: false
  },
  {
    key: 'price_without_vat', 
    label: 'Τιμή χωρίς ΦΠΑ', 
    sorter: false, 
    filter: false
  },
  {
    key: 'total_price', 
    label: 'Συνολική Αξία', 
    sorter: false, 
    filter: false
  },
  {
    key: 'delete', 
    label: '', 
    sorter: false, 
    filter: false
  }
];

const fields = [];

export default {
  name: 'Invoices',
  components: {
    'v-date-picker': DatePicker,
    Multiselect,
    AddExternalB2GInvoice,
  },
  data: () => {
    return {
      activeTab: 0,
      items: [],
      fields,
      fieldsEN,
      fieldsEL,
      invoice_ID: '',
      document_series: '',
      document_series_options: [],
      document_series_seira: '',
      document_series_seira_options: [],
      client: '',
      clients_options: [],
      invoice_client: '',
      invoice_clients_options: [],
      date: '',
      document_number: '',
      document_number_temp: '',
      invoice_services: '',
      servicesOptions: [],
      services: '',
      invoice_servicesOptions: [],
      client_afm: '',
      client_doy: '',
      client_address: '',
      client_company: '',
      client_phone: '',
      client_phone_2: '',
      client_town: '',
      client_state: '',
      client_postcode: '',
      client_name: '',
      quantity: '',
      price_without_vat: '',
      total_price: '',
      clients_raw: '',
      services_raw: '',
      invoice_clients_raw: '',
      document_series_raw: '',
      document_series_seira_raw: '',
      notes: '',
      vat_price: '',
      vat_prices_options: [],
      invoice_lang: '',
      invoice_lang_options: [{ label: 'Ελληνικά', value: 'greek' }, { label: 'Αγγλικά', value: 'english' }],
      exception_category: {},
      exception_categories: [],
      collapse: false,
      disabledField: true,
      showAdd: false,
      showAddVat: false,
      serviceLoopToDatatable: [],
      cilMinusBtn: cilMinus,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      loading: true,
      showMessage: false,
      dismissSecs: 7,
      alertIsShown: false,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      payment_status: 0,
      paid_amount: 0,
      payment_options: [],
      clientServices: [],
      clientCases: [],
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    },
    totalPrice() {
      if (this.serviceLoopToDatatable && this.serviceLoopToDatatable.length) {
        return parseFloat(this.serviceLoopToDatatable.reduce(function(a, b) { return a + parseFloat(b.total_price);}, 0));
      }
      return 0;
    },
    remainingPrice() {
      return (this.totalPrice - this.paid_amount).toFixed(2);
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    changePaidAmount() {
      if (this.payment_status.value == 2) {
        this.paid_amount = this.totalPrice;
      } else if (this.payment_status.value == 0) {
        this.paid_amount = 0;
      }
    },
    changeSeiraOptions(){
      let self = this;

        // Filter series by current language (Greek or English)
        const currentLang = self.invoice_lang.value === 'english' ? 'en' : 'gr';
        self.document_series_seira_options = self.document_series.seires.filter((item) => item.lang == currentLang);

        self.document_series_seira_options = self.document_series_seira_options.map((item) => {
          return {
            value: item.id,
            invoice_count: item.invoice_count + 1,
            lang: item.lang,
            label: item.name,
          }
        });

        self.document_series_seira = self.document_series_seira_options[0];

        let document_number_temp = self.document_series_seira.invoice_count;

        self.document_number =  ('00000' + document_number_temp).slice(-5);

        // Auto-select exception category based on document type (ONLY for English invoices)
        if (self.invoice_lang && self.invoice_lang.value === 'english' &&
            self.document_series && self.exception_categories.length > 0) {
          const label = self.document_series.label.toLowerCase();

          // European countries → Article 28
          if (label.includes('european') || label.includes('ενδοκοινοτικό') || label.includes('ετπυ') || label.includes('iec')) {
            self.exception_category = self.exception_categories.find((item) =>
              item.label.includes('28') || item.label.toLowerCase().includes('article 28')
            ) || self.exception_category;
          }
          // Third countries → Article 14
          else if (label.includes('third') || label.includes('τρίτης') || label.includes('τπυτχ') || label.includes('itc')) {
            self.exception_category = self.exception_categories.find((item) =>
              item.label.includes('14') || item.label.toLowerCase().includes('article 14')
            ) || self.exception_category;
          }
        }
    },

    addRow () {
      let self = this; 

      var id = 1;
      if (this.serviceLoopToDatatable.length) {
        id = Math.max.apply(Math,this.serviceLoopToDatatable.map(function(o){return o.id;})) + 1;
      }

      if (self.services && self.invoice_lang.value == 'greek') {
        self.notes = 'ΠΙΣΤΟΠΟΙΗΣΗ '+self.printServiceName(self.services.label)+' (Αρ. Υπόθ. '+self.services.label+') '+self.notes;
      } else if (self.services && self.invoice_lang.value == 'english') {
        self.notes = self.printServiceName(self.services.label)+' Certification for (Case Num. '+self.services.label+') '+self.notes;
      } else if (self.invoice_services) {
        self.notes = self.invoice_services.label +' '+ self.notes;
      }

      this.serviceLoopToDatatable.push({ id , services: self.services, invoice_services: self.invoice_services, notes: self.notes, quantity: self.quantity, price_without_vat: (self.price_without_vat*self.quantity).toFixed(2), total_price: (self.total_price*self.quantity).toFixed(2) });
      self.services = null;
      self.invoice_services = null;
      self.notes = '';
      self.quantity = 1;
      self.price_without_vat = '';
      self.total_price = '';

      this.showAdd = false;
      this.showAddVat = false;
    },
    printServiceName(service_label) {
      let self = this;

      // var tempClient = self.clients_raw.find((item) => { if (item.id == self.client.value) { return item; } });

      var tempCaseID = self.clientCases.find((item) => { if (item.case_code == service_label) { return item; } });

      var tempServiceName = self.services_raw.find((item) => { if (item.id == tempCaseID.service_id) { return item; } });

      return tempServiceName.name;
    },
    deleteRow(id) {
      this.serviceLoopToDatatable = this.serviceLoopToDatatable.filter((item) => item.id != id);
    },
    removeSelectedCases () {
      let self = this; 

      if (self.showAdd == true) {
        self.showAdd = false;
      }
    },
    selectedIsoCases (selected) {
      let self = this; 
      console.log('Selected: ',selected)
      if (selected) {
        if (self.showAdd == false) {
          self.showAdd = true;
        }

        // pass the price on price_without_vat
        var tempClient = self.clients_raw.find((item) => { if (item.id == self.client.value) { return item; } });
        console.log('Client: ',tempClient)
        // var tempServiceID = tempClient.cases.find((item) => { if (item.id == selected.value) { return item; } });
        var tempService = self.clientServices.find((item) => { if (item.id == selected.service_id) { return item; } });
        console.log('Service: ',tempService)
        if (tempService) {
          self.calculate_final_price(tempService.pivot.price_service);

          return self.price_without_vat = tempService.pivot.price_service;
        }
      }
    },
    selectedCases (selected) {
      let self = this; 

      if (selected) {
        if (self.showAdd == false) {
          self.showAdd = true;
        }
      }
    },
    removeSelectedClient () {
      let self = this;

      if (self.showAdd == true) {
        self.showAdd = false;
      }

      self.client_address = '';
      self.client_company = '';
      self.client_phone = '';
      self.client_phone_2 = '';
      self.client_town = '';
      self.client_state = '';
      self.client_postcode = '';
      self.client_afm = '';
      self.client_doy = '';
      self.client_name = '';
      self.notes = '';
      self.quantity = 1;
      self.price_without_vat = '';
      self.total_price = '';

      if (self.services) {
        self.services = null;
      }

      if (self.invoice_services) {
        self.invoice_services = null;
      }
    },
    selectedDocSer(val) {
      if (val) {
        this.document_number = ('00000' + val.invoice_count).slice(-5);
      }
    },
    selectedClient (val) {
      let self = this;
      
      
      console.log(val);
      if (val) {
        if (self.services) {
          self.services = null;
          self.notes = '';
          self.quantity = 1;
          self.price_without_vat = '';
          self.total_price = '';
        }

        if (self.invoice_services) {
          self.invoice_services = null;
          self.notes = '';
          self.quantity = 1;
          self.price_without_vat = '';
          self.total_price = '';
        }

        var temp = self.clients_raw.find((item) => { if (item.id == val.value) { return item; } });

        self.client_address = temp.address;
        self.client_company = temp.company;
        self.client_phone = temp.phone_number_1;
        self.client_phone_2 = temp.phone_number_2;
        self.client_town = temp.town;
        self.client_state = temp.state;
        self.client_postcode = temp.postcode;
        self.client_afm = temp.afm;
        self.client_doy = temp.doy;
        self.client_name = temp.contact_name;
        self.getClientCases(self.client.value);
        // self.servicesOptions = temp.cases.map((item) => {
        //   return {
        //     label: item.case_code,
        //     value: item.id
        //   }
        // })
        
      }
    },
    selectedInvoiceClient (val) {
      let self = this;

      if (val) {
        var temp = self.invoice_clients_raw.find((item) => { if (item.id == val.value) { return item; } });
      
        self.client_address = temp.address;
        self.client_company = temp.company;
        self.client_phone = temp.phone_number_1;
        self.client_phone_2 = temp.phone_number_2;
        self.client_town = temp.town;
        self.client_state = temp.state;
        self.client_postcode = temp.postcode;
        self.client_afm = temp.afm;
        self.client_doy = temp.doy;
        self.client_name = temp.name;
        self.notes = '';
        self.quantity = 1;
        self.price_without_vat = '';
        self.total_price = '';
      }
    },
    check_if_negative_quantity(quantity) {
      let self = this;

      if (quantity) {
        if (quantity <= 0) {
          return self.quantity = 1;
        } else if (quantity >= 1) {
          return quantity;
        }
      }
    },
    calculate_final_price (price_without_vat) {
      let self = this;

      if (price_without_vat) {
        // Accept both comma and dot as decimal separator
        if (typeof price_without_vat === 'string') {
          price_without_vat = price_without_vat.replace(',', '.');
          self.price_without_vat = price_without_vat;
        }
        let price_no_vat = parseFloat(price_without_vat);
        let fpa_percentage = this.vat_price.value;
        let price_with_vat = parseFloat(price_no_vat * fpa_percentage);

        let final_price_calculated = 0;
        

        var canceledInvoicesList = self.document_series_options.filter(opt => opt.label.includes('Ακυρωτικό')).map(item => item['value'])

        if(canceledInvoicesList.includes(self.document_series.value)){
           final_price_calculated = - (price_no_vat + price_with_vat);
        }else{
          final_price_calculated = price_no_vat + price_with_vat;
        }

        this.showAddVat = true;

        return self.total_price = final_price_calculated.toFixed(2);
      } else {
        this.showAddVat = false;

        return self.total_price = '';
      }
    },
    calculate_price_without_vat (total_price) {
      let self = this;

      if (total_price) {
        // Accept both comma and dot as decimal separator
        if (typeof total_price === 'string') {
          total_price = total_price.replace(',', '.');
          self.total_price = total_price;
        }
        let fpa_percentage = this.vat_price.value;
        let price_with_vat = parseFloat(1 + fpa_percentage);
        let final_price_without_vat_calculated = parseFloat(total_price) / price_with_vat;

        this.showAddVat = true;

        return self.price_without_vat = final_price_without_vat_calculated.toFixed(2);
      } else {
        this.showAddVat = false;

        return self.price_without_vat = '';
      }
    },
    selectedInvoiceLanguage (lang) {
      let self = this;

      if (lang.value == 'english') {
        self.vat_price = self.vat_prices_options.find((i) => i.value == 0);

        // Filter document series by language and English visibility
        self.document_series_options = self.document_series_raw
          .filter((item) => (item.lang === 'en' || item.lang === 'both') && item.is_visible_en)
          .map((item) => {
            return {
              value: item.id,
              label: item.english_name,
              seires: item.seires
            }
          });

        // Try to find European invoice type (check for various possible names)
        self.document_series = self.document_series_options.find((item) =>
          item.label.toLowerCase().includes('european') ||
          item.label.toLowerCase().includes('ενδοκοινοτικό') ||
          item.label.includes('ΕΤΠΥ')
        );

        // Fallback to first option if not found
        if (!self.document_series && self.document_series_options.length > 0) {
          self.document_series = self.document_series_options[0];
        }

        // Update seira options based on selected document series
        if (self.document_series) {
          self.changeSeiraOptions();
        }

        self.fields = self.fieldsEN;

      } else if (lang.value == 'greek') {
        self.vat_price = self.vat_prices_options.find((i) => i.value == 0.24);

        // Clear exception category for Greek invoices (not needed for domestic)
        self.exception_category = {};

        // Filter document series by language and Greek visibility
        self.document_series_options = self.document_series_raw
          .filter((item) => (item.lang === 'gr' || item.lang === 'both') && item.is_visible_gr)
          .map((item) => {
            return {
              value: item.id,
              label: item.greek_name,
              seires: item.seires
            }
          });

        self.document_series = self.document_series_options.find((item) => item.label == "Τιμολόγιο Παροχής Υπηρεσιών");

        // Update seira options based on selected document series
        self.changeSeiraOptions();

        self.fields = self.fieldsEL;
      }
    },
    store() {
        let self = this;

        let serviceLoopToDatatable = self.serviceLoopToDatatable.filter((item) => item.services && item.quantity && item.price_without_vat && item.total_price);
        serviceLoopToDatatable = self.serviceLoopToDatatable.map((item) => {
          let service, type;
          if (item.services) {
            service = item.services.value;
            type = 'case';
          }

          if (item.invoice_services) {
            service = item.invoice_services.value;
            type = 'service';
          }

            return {
                service: service,
                type: type,
                service_description: item.notes,
                service_quantity: item.quantity,
                price_without_vat: item.price_without_vat,
                total_price: item.total_price
            }
        });

        let client_id, client_type;
        if (self.client) {
          client_id = self.client.value;
          client_type = 'client';
        }

        if (self.invoice_client) {
          client_id = self.invoice_client.value;
          client_type = 'invoice_client';
        }

        let document_series_id = null;
        if (this.document_series) {
          document_series_id = this.document_series.value;
        }

        let document_series_seira_id = null;
        if (this.document_series_seira) {
          document_series_seira_id = this.document_series_seira.value;
        }

        let payment_status = null;
        if (this.payment_status) {
          payment_status = this.payment_status.value
        }

        let fpa_exception_id = self.exception_category.hasOwnProperty('value') ? self.exception_category.value : null;

        // DEBUG: Show myDATA data before sending
        alert(
          'myDATA Data Preview:\n\n' +
          'Document Type: ' + (self.document_series ? self.document_series.label : 'N/A') + '\n' +
          'Document Series: ' + (self.document_series_seira ? self.document_series_seira.label : 'N/A') + '\n' +
          'VAT %: ' + (self.vat_price ? (self.vat_price.value * 100) + '%' : 'N/A') + '\n' +
          'Exception Category: ' + (self.exception_category && self.exception_category.label ? self.exception_category.label : 'None') + '\n' +
          'Exception ID: ' + (fpa_exception_id || 'None')
        );

        axios.post('/api/invoices?token=' + localStorage.getItem("api_token"),
        {            
            invoice_language: self.invoice_lang.value,
            document_number: self.document_number,
            document_series_id: document_series_id,
            document_series_seira_id: document_series_seira_id,
            invoice_date: self.date,
            client_name: self.client_name,
            client_afm: self.client_afm,
            client_doy: self.client_doy,
            client_address: self.client_address,
            client_company: self.client_company,
            client_phone: self.client_phone,
            client_phone_2: self.client_phone_2,
            client_town: self.client_town,
            client_state: self.client_state,
            client_postcode: self.client_postcode,
            services: serviceLoopToDatatable,
            client_id: client_id,
            client_type: client_type,
            fpa_percentage: self.vat_price.value,
            fpa_exception_id: fpa_exception_id,
            paid_amount: self.paid_amount,
            payment_status: payment_status
        })
        .then(function (response) {
            self.message = 'Επιτυχής καταχώρηση τιμολογίου.';
            self.showAlert();

            self.invoice_ID = response.data.invoice_id;
            self.showInvoice(self.invoice_ID);
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    changeTab(tabIndex) {
      this.activeTab = tabIndex;

      // Tab indices: 0 = Greek, 1 = English, 2 = B2G, 3 = Settings, 4 = Payments
      if (tabIndex === 1) {
        // English Invoice tab
        this.invoice_lang = this.invoice_lang_options.find((i) => i.value == 'english');
        this.selectedInvoiceLanguage(this.invoice_lang);
      } else if (tabIndex === 0) {
        // Greek Invoice tab
        this.invoice_lang = this.invoice_lang_options.find((i) => i.value == 'greek');
        this.selectedInvoiceLanguage(this.invoice_lang);
      }
    },
    InvoiceLink (id) {
      return `invoice/${id.toString()}`
    },
    showInvoice ( id ) {
      this.$router.replace({path: `/invoices/${id.toString()}`});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getInvoice () {
      let self = this;
      axios.get('/api/invoices/create?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.clients_raw = response.data.clients;
        self.services_raw = response.data.services;
        self.invoice_clients_raw = response.data.invoice_clients;
        self.document_series_raw = response.data.document_series;
        self.document_series_seira_raw = response.data.document_series_seira;

        self.document_number_temp = response.data.document_series_seira[0].invoice_count + 1;

        // Initial load: filter by Greek language and Greek visibility
        self.document_series_options = response.data.document_series
          .filter((item) => (item.lang === 'gr' || item.lang === 'both') && item.is_visible_gr)
          .map((item) => {
            return {
              value: item.id,
              label: item.greek_name,
              seires: item.seires
            }
          });
        self.document_series = self.document_series_options.find((item) => item.label == "Τιμολόγιο Παροχής Υπηρεσιών");
        
        // self.document_series_seira_options = response.data.document_series_seira.filter((item) => item.lang == 'gr');
        self.document_series_seira_options = self.document_series.seires.filter((item) => item.lang == 'gr');

        self.document_series_seira_options = self.document_series_seira_options.map((item) => {
          return {
            value: item.id,
            invoice_count: item.invoice_count + 1,
            lang: item.lang,
            label: item.name,
          }
        });
        self.document_series_seira = self.document_series_seira_options[0];

        self.document_number =  ('00000' + self.document_number_temp).slice(-5);

        self.clients_options = response.data.clients.map((item) => {
          return {
            value: item.id,
            label: item.company,
            cases: item.cases
          }
        });

        self.invoice_clients_options = response.data.invoice_clients.map((item) => {
          return {
            value: item.id,
            label: item.company,
          }
        });

        self.invoice_servicesOptions = response.data.invoice_services.map((item) => {
          return {
            value: item.id,
            label: item.name,
          }
        });

        self.vat_prices_options = response.data.vat_prices.map((item) => {
          return {
            value: item.percentage,
            label: item.vat,
          }
        });

        self.exception_categories = response.data.vat_exceptions.map((item) => {
          return {
            value: item.id,
            label: item.name
          }
        })
        self.payment_options = response.data.payment_options.map((item, index) => {
          return {
            value: index,
            label: item
          }
        });
        self.payment_status = self.payment_options[0]
        self.vat_price = self.vat_prices_options.find((item) => item.value == 0.24);

        self.quantity = 1;

        self.invoice_lang = self.invoice_lang_options.find((i) => i.value == 'greek');

        self.fields = self.fieldsEL;

        self.loading = false;
      }).catch(function (error) {
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    getClientCases($clientId){
      let self = this;
      axios.get('/api/client/'+$clientId+'/cases?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        const cases = response.data.cases;
        console.log(response.data.cases)
        self.servicesOptions = cases.map((item) => {
          return {
            label: item.case_code,
            value: item.id,
            service_id: item.service_id
          }
        })
        self.clientCases = response.data.cases
        self.clientServices = response.data.services
        
      })
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function() {
    this.date = moment(new Date()).format('YYYY-MM-DD');
    this.getInvoice();
  }
}
</script>

<style scoped>
.invoice-nav-btn {
  padding: 12px 20px;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid #d8dbe0;
  transition: all 0.2s ease;
}

.invoice-nav-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.invoice-nav-btn.btn-primary {
  border-color: #321fdb;
  box-shadow: 0 2px 8px rgba(50, 31, 219, 0.3);
}

.invoice-nav-btn .c-icon {
  margin-right: 6px;
}

@media (max-width: 768px) {
  .invoice-nav-btn {
    font-size: 12px;
    padding: 10px 12px;
  }
}
</style>
